import { render, staticRenderFns } from "./bodyUploadDocs.vue?vue&type=template&id=8721e91c&scoped=true"
import script from "./bodyUploadDocs.vue?vue&type=script&lang=js"
export * from "./bodyUploadDocs.vue?vue&type=script&lang=js"
import style0 from "./bodyUploadDocs.vue?vue&type=style&index=0&id=8721e91c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8721e91c",
  null
  
)

export default component.exports